import JournalVoucher from "./JournalVoucher";
import PaymentVoucher from "./PaymentVoucher";
import ReceiptVoucher from "./ReceiptVoucher";
import ShowVoucher from "./ShowVoucher";

export default { ReceiptVoucher, PaymentVoucher, JournalVoucher, ShowVoucher };
